import { useState as d, useLayoutEffect as c, useEffect as l } from "react";
var o = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, u = typeof o == "object" && o && o.Object === Object && o, h = typeof self == "object" && self && self.Object === Object && self;
u || h || Function("return this")();
var m = typeof window < "u" ? c : l, b = typeof window > "u";
function p(n, {
  defaultValue: f = !1,
  initializeWithValue: s = !0
} = {}) {
  const i = (e) => b ? f : window.matchMedia(e).matches, [r, a] = d(() => s ? i(n) : f);
  function t() {
    a(i(n));
  }
  return m(() => {
    const e = window.matchMedia(n);
    return t(), e.addListener ? e.addListener(t) : e.addEventListener("change", t), () => {
      e.removeListener ? e.removeListener(t) : e.removeEventListener("change", t);
    };
  }, [n]), r;
}
export {
  p as u
};
